import type { ReactNode } from 'react';
import React from 'react';

import { EmptyState } from 'app/components/pages/Extranet/commons/EmptyState/EmptyState';

import styles from './TableEmptyState.module.scss';

export type TableEmptyStateConfig = {
  title: string;
  description: string;
  icon?: ReactNode;
};

export const TableEmptyState: React.FC<TableEmptyStateConfig> = ({
  title,
  description,
  icon,
}) => {
  return (
    <div className={styles.tableEmptyStateContainer}>
      <EmptyState title={title} description={description} icon={icon} />
    </div>
  );
};
